import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Stack,
  InputGroup,
  InputRightElement,
  useColorModeValue,
  Text,
  useToast,
  Heading,
  Alert,
  AlertIcon
} from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import image from "../../assets/images/signInImage.jpg";

import axiosClient, { linkAPI } from "../../axios-client";
import { useStateContext } from "../../context/ContextProvider";
import React, { useState, useEffect, useRef } from 'react';
import { EditIcon, ViewOffIcon, ViewIcon } from '@chakra-ui/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { TfiReload } from 'react-icons/tfi';
import Select from "react-select";
import countryData from '../../assets/dataJson/countries.json';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
const ResetPwdPage = () => {
  const { t } = useTranslation();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const { userId, token, expires } = useParams();
  const navigate = useNavigate();
  const [isExpired, setIsExpired] = useState(false);
  //toast variable
  const toast = useToast()
  ////////////////////////// VALIDATION DE MOT DE PASSE /////////////////////////////////////////
  const [passwordStrength, setPasswordStrength] = useState('');
  const [passwordColor, setPasswordColor] = useState('');
  useEffect(() => {
    const expirationTime = new Date(expires);
    const currentTime = new Date();

    if (expirationTime > currentTime) {
      setIsExpired(false);
    } else {
      setIsExpired(true);
    }
  }, [expires]);




  const checkPasswordStrength = () => {
    const specialchar = /[@#$%^&+=!*_|èàç()/."';:,?ù]/;
    const minLengthRegex = /^.{8,}$/;
    const startLength = /^.{2,}$/;
    const digitRegex = /\d/;
    const lowercaseRegex = /[a-z]/;
    const uppercaseRegex = /[A-Z]/;

    let missingRequirements = [];

    if (!specialchar.test(newPassword)) {
      missingRequirements.push(t("caractère spécial"));
    } else if (!lowercaseRegex.test(newPassword)) {
      missingRequirements.push(t("minuscule"));
    } else if (!uppercaseRegex.test(newPassword)) {
      missingRequirements.push(t("majuscule"));
    } else if (!digitRegex.test(newPassword)) {
      missingRequirements.push(t("chiffres"));
    } else if (!minLengthRegex.test(newPassword)) {
      missingRequirements.push(t("longueur minimale de 8 caractères"));
    }

    if (missingRequirements.length > 0) {
      const missingText = `${t("Vous avez besoin de")} ${missingRequirements.join(", ")} ${t("dans votre mot de passe.")}`;
      setPasswordStrength(missingText);
      setPasswordColor('red.400');
    } else {
      setPasswordStrength(t('Le mot de passe est correct!'));
      setPasswordColor('green.400');
    }
  }
  useEffect(() => {
    checkPasswordStrength();
  }, [newPassword]);



  // check the password complexity
  const isPasswordValid = (password) => {
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!*_|èàç()/."';:,?ù])[0-9a-zA-Z@#$%^&+=!*_|èàç()/."';:,?ù]{8,}$/;
    const specialchar = /[@#$%^&+=!*_|èàç()/."';:,?ù]/;
    const minLengthRegex = /^.{8,}$/;
    const digitRegex = /\d/;
    const lowercaseRegex = /[a-z]/;
    const uppercaseRegex = /[A-Z]/;

    let errors = [];

    if (!minLengthRegex.test(password)) {
      errors.push(t('Le mot de passe doit comporter au moins 8 caractères.'));
    }

    if (!digitRegex.test(password)) {
      errors.push(t('Le mot de passe doit contenir au moins un chiffre.'));
    }

    if (!lowercaseRegex.test(password)) {
      errors.push(t('Le mot de passe doit contenir au moins une lettre minuscule.'));
    }

    if (!uppercaseRegex.test(password)) {
      errors.push(t('Le mot de passe doit contenir au moins une lettre majuscule.'));
    }
    if (!specialchar.test(password)) {
      errors.push(t('Le mot de passe doit contenir au moins un caractère spécial (@#$%^&+=).'));
    }
    if (password.length > 20) {
      errors.push(t('Le mot de passe ne doit pas dépasser 20 caractères.'));
    }

    if (errors.length > 0) {
      setMessage(errors[0]);
      return false;
    }

    return passwordRegex.test(password);
  };

  // reset password 
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!isPasswordValid(newPassword)) {
      return;
    }
    try {
      const response = await axios.put(`${linkAPI}/reset_password/${userId}/`, {
        new_password: newPassword,
        confirm_password: confirmPassword,
      });
      if (response.data.success) {
        toast({
          position: 'top-center',
          description: t("le mot de passe est modifié avec succès"),
          status: 'success',
          duration: 2000,
          isClosable: true,
          variant:"left-accent"
        });
        navigate('/login')

      }
      setMessage(response.data.error);
    } catch (err) {
      setError(err.response.data.error);
    }
  };
  const colorModeValue = useColorModeValue('gray.50', 'gray.800');
  const colorModeValue1 = useColorModeValue('white', 'gray.700');

  return (
    <Flex
      minH={'100vh'}
      align={'center'}
      justify={'center'}
      bg={'gray.900'}
      position="relative"
      backgroundSize={'cover'}
      bgImage={image}
      overflow="hidden"
    >
      {/* Dark overlay */}
      <Box
        position="absolute"
        top={0} left={0} right={0} bottom={0}
        bg="blackAlpha.400"
        zIndex={0}
      />
      {isExpired ? (
        <Box position="relative" zIndex={1} className="animate-scale-in">
          <Alert
            status="error"
            rounded="14px"
            bg="rgba(254, 178, 178, 0.12)"
            border="1px solid"
            borderColor="rgba(254, 178, 178, 0.2)"
            px={6}
            py={4}
            backdropFilter="blur(20px)"
          >
            <AlertIcon />
            <Text fontSize="14px" color="red.200">
              {t("Le lien a expiré . Vous avez dépasser le temps imparti")}
            </Text>
          </Alert>
        </Box>
      ) : (
        <Flex
          alignItems={'center'}
          justifyContent={'center'}
          w={"100%"}
          h={'100vh'}
          position="relative"
          zIndex={1}
        >
        <Flex
          gap={4}
          w={{ base: "92%", sm: "85%", md: '460px' }}
          backdropFilter='blur(20px) saturate(180%)'
          WebkitBackdropFilter='blur(20px) saturate(180%)'
          padding={{ base: 8, md: 10 }}
          direction='column'
          rounded={"20px"}
          background='rgba(20, 15, 40, 0.75)'
          border="1px solid"
          borderColor="whiteAlpha.100"
          boxShadow="0 25px 60px -12px rgba(0,0,0,0.4), 0 0 40px -8px rgba(128, 90, 213, 0.1)"
          className="animate-scale-in"
        >
          <Heading
            color={"white"}
            lineHeight={1.1}
            fontSize={{ base: '22px', md: '26px' }}
            fontWeight="800"
            letterSpacing="-0.02em"
          >
            {t("Réinitialisation de mot de passe")}
          </Heading>
          {message && (
            <Alert
              status="error"
              rounded="12px"
              bg="rgba(254, 178, 178, 0.12)"
              border="1px solid"
              borderColor="rgba(254, 178, 178, 0.2)"
            >
              <AlertIcon />
              <Text fontSize="13px" color="red.200">{message}</Text>
            </Alert>
          )}
          <FormControl mt={2}>
            <FormLabel color="whiteAlpha.700" fontSize="13px" fontWeight="600">{t("Nouveau mot de passe")}</FormLabel>
            <InputGroup>
              <Input
                type={showPassword ? 'text' : 'password'}
                id="new_password"
                color={'white'}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                onCopy={(e) => e.preventDefault()}
                h="48px"
                bg="whiteAlpha.50"
                border="1px solid"
                borderColor="whiteAlpha.200"
                borderRadius="12px"
                fontSize="14px"
                _hover={{ borderColor: "whiteAlpha.300" }}
                _focus={{
                  borderColor: "purple.400",
                  boxShadow: "0 0 0 3px rgba(128, 90, 213, 0.2)",
                  bg: "whiteAlpha.100"
                }}
                transition="all 0.2s ease"
              />
              <InputRightElement h={'full'}>
                <Button
                  color="whiteAlpha.600"
                  variant={'ghost'}
                  _hover={{ color: "white", bg: "whiteAlpha.100" }}
                  borderRadius="lg"
                  onClick={() => setShowPassword((showPassword) => !showPassword)}
                >
                  {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                </Button>
              </InputRightElement>
            </InputGroup>
          </FormControl>
          {newPassword.length > 0 && (
            <Text align="left" justify="left" fontSize="12px" color={passwordColor} fontWeight="500">
              {passwordStrength}
            </Text>
          )}
          <FormControl >
            <FormLabel color="whiteAlpha.700" fontSize="13px" fontWeight="600">{t("Confirmer mot de passe")}</FormLabel>
            <Input
              type="password"
              id="confirm_password"
              value={confirmPassword}
              color={'white'}
              onChange={(e) => setConfirmPassword(e.target.value)}
              h="48px"
              bg="whiteAlpha.50"
              border="1px solid"
              borderColor="whiteAlpha.200"
              borderRadius="12px"
              fontSize="14px"
              _hover={{ borderColor: "whiteAlpha.300" }}
              _focus={{
                borderColor: "purple.400",
                boxShadow: "0 0 0 3px rgba(128, 90, 213, 0.2)",
                bg: "whiteAlpha.100"
              }}
              transition="all 0.2s ease"
            />
          </FormControl>
          <Stack spacing={6} mt={2}>
            <Button
              name="submit"
              type="submit"
              onClick={handleFormSubmit}
              colorScheme="purple"
              h="48px"
              fontSize="14px"
              fontWeight="600"
              borderRadius="12px"
              bg="linear-gradient(135deg, #7B5EA7 0%, #9F7AEA 100%)"
              _hover={{
                bg: "linear-gradient(135deg, #6B4E97 0%, #8F6ADA 100%)",
                transform: "translateY(-1px)",
                boxShadow: "0 8px 25px -5px rgba(128, 90, 213, 0.4)"
              }}
              _active={{ transform: "scale(0.98)" }}
              transition="all 0.2s ease"
              letterSpacing="-0.01em"
            >
              {t("Réinitialiser")}
            </Button>
          </Stack>
        </Flex>
        </Flex>
      )}
    </Flex>
  );

}

export default ResetPwdPage